import axios from 'axios';
import { ELocalStorageKeys } from '../constants/enums';
import { webStorageUtil } from 'state/webStorage.state.service';
import { getEnvVariable } from '@appcharge/shared-ui';

export const baseURLPromise = async (): Promise<string> => {
  const baseUrl = getEnvVariable('REACT_APP_API_BASE_URL', process.env.REACT_APP_API_BASE_URL) || 'https://api-store.appcharge.com';
  axios.defaults.baseURL = baseUrl;
  return baseUrl;
};

export default function useAxios() {
  const post = async <T = any>(
    path: string,
    { data, headers }: { data: any; headers: any },
    noToken = false
  ) => {
    await baseURLPromise();
    const token = webStorageUtil.getAny(ELocalStorageKeys.SESSION_TOKEN);

    // Determine if Authorization header should be included
    const shouldIncludeAuth =
      !noToken && !(path === '/store/auth/login/external' && token === null);

    return await axios<T>({
      url: path,
      method: 'POST',
      headers: {
        ...headers,
        Authorization: shouldIncludeAuth ? `Bearer ${token}` : undefined,
        'x-session-id': webStorageUtil.getStorageWithFallback()?.id,
      },
      data,
    }).catch((err) => {
      throw err;
    });
  };

  const get: (
    path: string,
    noToken?: boolean,
    params?: any,
    headers?: any
  ) => Promise<any> = async (path, noToken = false, params, headers = {}) => {
    await baseURLPromise();
    const token = webStorageUtil.getAny(ELocalStorageKeys.SESSION_TOKEN);
    const response = await axios({
      url: path,
      method: 'GET',
      headers: {
        ...headers,
        Authorization: !noToken ? `Bearer ${token}` : undefined,
        'x-session-id': webStorageUtil.getStorageWithFallback()?.id,
      },
      params: params || undefined,
    });
    return response.data;
  };

  return { post, get };
}
